import React, { useState, useEffect } from "react";
import UserProfileInput from "./UserProfileInput";
import { Col, Row, Spinner } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { updateProfile } from "../../redux/thunks/userThunks";
import { initializeUserFromStorage } from "../../redux/slices/userSlice";
import UserProfileCountry from "./UserProfileCountry";
import UserProfileDate from "./UserProfileDate";
import UserProfileSelect from "./UserProfileSelect";
import { useTranslation } from "react-i18next";

const parseAddress = (addressStr = "") => {
  const [
    line1 = "",
    line2 = "",
    city = "",
    province = "",
    postalCode = "",
    country = "",
  ] = typeof addressStr === "string" ? addressStr.split(",") : [];
  return { line1, line2, city, province, postalCode, country };
};

const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other / Prefer not to say", value: "other" },
];

const identityTypeOptions = [
  { label: "Visitor Visa", value: "visa" },
  { label: "Permanent Resident", value: "pr" },
  { label: "Citizenship", value: "citizenship" },
];

const occupationOptions = [
  { label: "Student", value: "student" },
  { label: "Employed", value: "employed" },
  { label: "Self-employed", value: "self_employed" },
  { label: "Unemployed", value: "unemployed" },
  { label: "Retired", value: "retired" },
];

const incomeRangeOptions = [
  { label: "< $30,000", value: "<30000" },
  { label: "$30,000 – $60,000", value: "30000-60000" },
  { label: "$60,000 – $100,000", value: "60000-100000" },
  { label: "$100,000 – $200,000", value: "100000-200000" },
  { label: "> $200,000", value: ">200000" },
];

const purposeOfFundsOptions = [
  { label: "Savings / Investment", value: "savings" },
  { label: "Salary / Employment", value: "salary" },
  { label: "Business Revenue", value: "business" },
  { label: "Gift / Family Support", value: "gift" },
  { label: "Other", value: "other" },
];

const UserProfileAdditional = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeUserFromStorage());
  }, [dispatch]);

  const userInfo = useSelector((state) => state.user.user.data);

const [formData, setFormData] = useState({
  nick_name: "",
  nationality: "",
  gender: "",
  canadian_identity_type: "",
  occupation: "",
  employer_info: "",
  annual_income_range: "",
  purpose_of_funds: "",
});

useEffect(() => {
  if (!userInfo) return;
  setFormData((s) => ({
    ...s,
    nick_name: userInfo.nick_name ?? "",
    nationality: userInfo.nationality ?? "",
    gender: userInfo.gender ?? "",
    canadian_identity_type: userInfo.canadian_identity_type ?? "",
    occupation: userInfo.occupation ?? "",
    employer_info: userInfo.employer_info ?? "",
    annual_income_range: userInfo.annual_income_range ?? "",
    purpose_of_funds: userInfo.purpose_of_funds ?? "",
  }));
}, [userInfo]);

const handleChange = (field) => (e) => {
  setFormData((s) => ({ ...s, [field]: e.target.value }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  const payload = { ...userInfo, ...formData };
  try {
    await dispatch(updateProfile(userInfo.id, payload));
    dispatch(initializeUserFromStorage());
    alert("Profile updated successfully!");
  } catch (err) {
    alert("Failed to update profile.");
  }
};


  return (
    <div className="col-xl-10">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">{`Optional User Information`}</h4>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit} className="personal_validate">
            <div className="form-row">
              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileInput
                    fieldLabel={"Nick Name"}
                    name="nick_name"
                    value={formData.nick_name}
                    onChange={handleChange("nick_name")}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileSelect
                    fieldLabel={"Gender"}
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange("gender")}
                    options={genderOptions}
                    placeholder={"Select gender"}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileCountry
                    fieldLabel={"Nationality"}
                    name="nationality"
                    value={formData.nationality}
                    onChange={handleChange("nationality")}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileSelect
                    fieldLabel={"Canadian Identity Type"}
                    name="canadian_identity_type"
                    value={formData.canadian_identity_type}
                    onChange={handleChange("canadian_identity_type")}
                    options={identityTypeOptions}
                    placeholder={"Select identity type"}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileSelect
                    fieldLabel={"Occupation"}
                    name="occupation"
                    value={formData.occupation}
                    onChange={handleChange("occupation")}
                    options={occupationOptions}
                    placeholder={"Select occupation"}
                  />
                </Col>
                <Col xs={6}>
                  <UserProfileSelect
                    fieldLabel={"Annual Income Range"}
                    name="annual_income_range"
                    value={formData.annual_income_range}
                    onChange={handleChange("annual_income_range")}
                    options={incomeRangeOptions}
                    placeholder={"Select income range"}
                  />
                </Col>
              </Row>
              <UserProfileInput
                fieldLabel={"Employer Info"}
                name="employer_info"
                value={formData.employer_info}
                onChange={handleChange("employer_info")}
              />
              <Row className="align-items-center">
                <Col xs={6}>
                  <UserProfileSelect
                    fieldLabel={"Purpose of Funds"}
                    name="purpose_of_funds"
                    value={formData.purpose_of_funds}
                    onChange={handleChange("purpose_of_funds")}
                    options={purposeOfFundsOptions}
                    placeholder={"Select purpose"}
                  />
                </Col>
                <Col xs={6}></Col>
              </Row>

              <div className="form-group col-12">
                <button type="submit" className="btn btn-success ps-5 pe-5">
                  {t("save.label")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserProfileAdditional;
